<template>
  <div v-if="active" class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50"></div>
  <div v-if="active" class="fixed inset-0 flex justify-center items-center z-50 blur-none my-16" @click="closePopup">
    <div
      class="bg-[#fff] w-[670px] my-52 rounded-3xl overflow-hidden h-full flex flex-col border-2 border-b-gray-300 absolute"
      @click="handleClickPropagation">
      <span class="absolute right-6 top-2 scale-[240%]" @click="closePopup">&times;</span>
      <div class="flex flex-col flex-grow h-full mx-10 mt-6">
        
        <span class="text-left text-lg mx-8"><span class="font-semibold">{{ $t('Pos.Product')+": " }}</span>{{ selectedItem.name }}</span>
        
        <LbrxNumPad :amountToGive="quantity" @addAmount="addAmount" :cashierMode="true" @confirmAction="confirmQty" />
      </div>
    </div>
  </div>
</template>

<script>
import LbrxNumPad from "@/components/LbrxNumPad.vue"
export default {
  name: "LbrxQuantityPopup",
  components: {
    LbrxNumPad
  },
  data() {
    return {
      activeKey: '0',
      checkedItems: [],
      quantity: ""
    };
  },
  props: {
    active: {
      required: true,
      value: Boolean
    },
    selectedItem: {
      required: true,
      value: Object
    }
  },
  computed: {
    productPriceFormat() {
      return this.selectedItem.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    additionalIngrediants() {
      return this.checkedItems.map((el) => {
        return {
          id: el.id,
          qte: 1
        }
      });
    }
  },
  methods: {
    closePopup() {
      this.reset();
      this.$emit("closePopup")
      this.$emit("closeQuantityPopup")
    },
    reset() {
      this.checkedItems = [];
    },
    handleClickPropagation() {
      event.stopPropagation();
    },
    confirmQty() {
      this.$emit("confirmQty", this.quantity)
      this.quantity = "";
    },
    addAmount(item) {
      if (item === -1) {
        this.quantity = "";
      } else if (item === -2) {
        this.quantity = this.pinCode.substring(0, this.pinCode.length - 1);
      } else {
        this.quantity += item;
      }
    }
  }
};
</script>

<style scoped>
input[type=checkbox] {
  transform: scale(1.5);
}
</style>